import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { MatchSticker } from 'dashboard/components/ChecksTableRow/Components';
import { IdAamvaDatabaseLookup } from 'dashboard/models/check';

export const computeIdAamvaDatabaseLookupMetadata = (
  check: IdAamvaDatabaseLookup,
): CheckMetadata => {
  const {
    'document-identification-number': documentIdentificationNumberMatch,
    'name-first': nameFirstMatch,
    'name-last': nameLastMatch,
    birthdate: birthdateMatch,
  } = check.metadata?.['aamva-match-results'] || {};

  const metadataItems = [];

  if (nameFirstMatch) {
    metadataItems.push({
      label: 'First name',
      value: <MatchSticker match={nameFirstMatch} />,
    });
  }
  if (nameLastMatch) {
    metadataItems.push({
      label: 'Last name',
      value: <MatchSticker match={nameLastMatch} />,
    });
  }
  if (birthdateMatch) {
    metadataItems.push({
      label: 'Birthdate',
      value: <MatchSticker match={birthdateMatch} />,
    });
  }
  if (documentIdentificationNumberMatch) {
    metadataItems.push({
      label: 'ID number',
      value: <MatchSticker match={documentIdentificationNumberMatch} />,
    });
  }

  return {
    metadata: createSimpleCheckMetadataArray(metadataItems),
    hideIfVerificationPassed: false,
  };
};
